<!--
calculator
root component

https://phrase.com/blog/posts/how-to-localize-a-svelte-app-with-svelte-i18n/

AT
20.09.21
-->

<svelte:window
	on:dataUpdated={update}
/>

<script>
	//import SvgSprite from '../_shared/components/svg-sprite.svelte'
	import { dictionary, locale, _ } from 'svelte-i18n'

	export let data = {
		'feeding_rates': {},
		'ages': [],
		'age': false,
		'ageIndex': 0,
		'masses': [],
		'mass': 0,
		'feeding_rate': false,
		}

	////i18n

	dictionary.set({
		en: {
			age: 'Age, weeks',
			mass: 'Mass, kg',
			feeding_rate: 'Daily feeding rate, g',
		},
		ru: {
			age: 'Возраст, недели',
			mass: 'Масса, кг',
			feeding_rate: 'Дневная норма корма, г',
		},
	})

	let locale_ = window.location.href.indexOf('/en/') !==-1? 'en' : 'ru';
	locale.set(locale_)

	////

	function _compareNumbers(a,b) {
		return a-b
	}

	function update(e){

		data = {
			'feeding_rates': e.detail.feeding_rates,
			'ages': [],
			'age': false,
			'ageIndex': 0,

			'masses': [],
			'mass': 0,
			'massIndex': 0,

			'feedingRate': 0,
			}

		for( let age in data.feeding_rates ) {
			data.ages.push(age)
		}
		data.age = data.ages[data.ageIndex]

		for( let mass in data.feeding_rates[data.age]){
			if( !data.feeding_rates[data.age][mass] || data.feeding_rates[data.age][mass] === null ) continue
			data.masses.push(mass)
		}

		data.masses.sort(_compareNumbers)
		data.mass = data.masses[0]
		data.massIndex = 0

//console.log('data.ages:', data.ages)
//console.log('data.masses:', data.masses)

		setFeedingRate()
	}

	function setAge(index){
		data.ageIndex = index
		data.age = data.ages[index]

		data.masses = []
		for( let mass in data.feeding_rates[data.age]){
			if( !data.feeding_rates[data.age][mass] || data.feeding_rates[data.age][mass] === null ) continue
			data.masses.push(mass)
			}
		data.masses.sort(_compareNumbers)
	}

	function setMass(index){
		data.massIndex = index
		data.mass = data.masses[data.massIndex]
		}

	function setMinimalMass(){
		data.mass = data.masses.find(a=>a!==undefined)
		data.massIndex = data.masses.indexOf(data.mass) || 0
		}

	function setFeedingRate(){
		data.feedingRate = false
		data.feedingRate = data.ages.length > 1 ? data.feeding_rates[data.age][data.mass] : data.feeding_rates[''][data.mass]
	}

</script>

{ #if data.ages.length > 1 }
	<div class="XL v-padded centered">
		{ $_('age') }
		<!--
		<br>
		<strong>
			{ data.ages[data.ageIndex] }
		</strong>
		-->
		<input bind:value={ data.ageIndex } on:change={ () => { setAge(data.ageIndex); setMinimalMass(); setFeedingRate() } } type="range" min=0 max={ data.ages.length - 1 }>
		<div class="range-labels flex flex-middle flex-space-between">
			{ #each data.ages as age, index }
				<a class="{ age==data.age? 'selected' : '' } half-padded range-label" on:click={ () => { setAge(index); setMinimalMass(); setFeedingRate() } }>
					{ age }
				</a>
			{ /each }
		</div>
	</div>
{ /if }

{ #if data.masses.length }
	<div class="XL v-padded centered">
		{ $_('mass') }
		<!--
		<br>
		<strong>
			{ data.masses[data.massIndex] }
		</strong>
		-->
		<input bind:value={ data.massIndex } on:change={ () => { setMass(data.massIndex); setFeedingRate() } } type="range" min=0 max={ data.masses.length - 1 }>
		<div class="range-labels flex flex-middle flex-space-between">
			{ #each data.masses as mass, index }
				<a class="{ mass==data.mass? 'selected' : '' } half-padded range-label" on:click={ () => { setMass(index); setFeedingRate() } }>
					{ mass }
				</a>
			{ /each }
		</div>
	</div>
{ /if }

{ #if data.feedingRate }
	<div class="X3L v-padded centered">
		{ $_('feeding_rate') }
		<br>
		<strong>
			{ data.feedingRate }
		</strong>
	</div>
{ /if }